import { Box } from "@mui/joy";
import { ComponentProps } from "react";

import { DataGrid } from "../../";

type DataGridProps = ComponentProps<typeof DataGrid>;

/** Admin list pages only — flex-fills the grid without changing the shared DataGrid component. */
export default function FullHeightDataGrid(props: DataGridProps) {
    return (
        <Box
            flex={1}
            display="flex"
            flexDirection="column"
            sx={{
                minHeight: 0,
                "& > div": {
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                },
                "& .ag-root-wrapper": {
                    flex: 1,
                    minHeight: 0,
                },
            }}
        >
            <DataGrid {...props} />
        </Box>
    );
}
